import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import {customAxios} from "../functions";



const name = 'discovery';
//const entity = 'dashboard';
//const entities = 'dashboard';
const initialState = createInitialState();
const extraActions = createExtraActions();
const extraReducers = createExtraReducers();
const slice = createSlice({ name, initialState, extraReducers });



export const discoveryActions = { ...slice.actions, ...extraActions };
export const discoveryReducer = slice.reducer;



function createInitialState() {
    return {
        filter: {
            specialities: null,
            continents: null,
            search_terms: null,
            professional_activities: null,
            profile_completeness_options: null
        }
    }
}

function createExtraActions() {


    return {
        // getAll: getAll(),
        //getById: getById(),
        // create: create(),
        // update: update(),
        // delete: _delete(),
        // getPaginatedList: getPaginatedList()
        getAllSpecialities: getAllSpecialities(),
        getAllContinents: getAllContinents(),
        updateContinentFilter: updateContinentFilter(),
        updateSpecialityFilter: updateSpecialityFilter(),
        getAllSearchTerms: getAllSearchTerms(),
        getAllProfessionalActivities: getAllProfessionalActivities(),
        updateProfessionalActivityFilter: updateProfessionalActivityFilter(),
        updateSearchTerm: updateSearchTerm(),
        getAllProfileCompletenessOptions: getAllProfileCompletenessOptions(),
        updateProfileCompletenessOptionFilter: updateProfileCompletenessOptionFilter(),
        setFilter: setFilter()
    };

    function getAllSpecialities() {

        return createAsyncThunk(
            `${name}/getAllSpecialities`,
            async function () {
                try {
                    const responseData = [
                        {id: 1, name: "Oncology", display_name: "Oncology", selected: false},
                        {id: 2, name: "Gastroenterology", display_name: "Gastroenterology", selected: false},
                        {id: 3, name: "Rheumatology", display_name: "Rheumatology", selected: false},
                        {id: 4, name: "Nephrology", display_name: "Nephrology", selected: false},
                        {id: 5, name: "Infectious Disease", display_name: "Infectious Disease", selected: false},
                        {id: 6, name: "Hematology", display_name: "Hematology", selected: false},
                        {id: 7, name: "Neurology", display_name: "Neurology", selected: false},
                        {id: 8, name: "Others", display_name: "Others", selected: false}
                    ];

                    return responseData;
                } catch (error) {
                    return []
                }
            }
        );
    }

    function updateSpecialityFilter() {
        return createAsyncThunk(
            `${name}/updateSpecialityFilter`,
            async function (updatedFilter) {
                try {
                    const responseData = updatedFilter;
                    return responseData;
                } catch (error) {
                    return []
                }
            }
        );
    }

    // function getAllContinents() {
    //     return createAsyncThunk(
    //         `${name}/getAllContinents`,
    //         async function () {
    //             try {
    //                 // const responseData = [
    //                 //         {id: 1, name: "USA", display_name: "US", selected: false},
    //                 //         {id: 2, name: "UK", display_name: "UK", selected: false},
    //                 //         {id: 3, name: "Europe", display_name: "Europe", selected: false},
    //                 //         {id: 4, name: "Asia-Pacific", display_name: "Asia-Pacific", selected: false},
    //                 //         {id: 5, name: "Middle East", display_name: "Middle East", selected: false}
    //                 // ];
    //                 const responseData = [
    //                     {id: 1, name: "Asia", display_name: "Asia", selected: false, show_country_filter: false, countries: []},
    //                     {id: 2, name: "Europe", display_name: "Europe", selected: false, show_country_filter: false, countries: []},
    //                     {id: 3, name: "Africa", display_name: "Africa", selected: false, show_country_filter: false, countries: []},
    //                     {id: 4, name: "Oceania", display_name: "Oceania", selected: false, show_country_filter: false, countries: []},
    //                     {id: 5, name: "America", display_name: "America", selected: false, show_country_filter: false, countries: [
    //                             {id: 1, name: "United States of America", display_name: "United States of America", selected: false},
    //                             {id: 2, name: "Brazil", display_name: "Brazil", selected: true},
    //                             {id: 3, name: "Colombia", display_name: "Colombia", selected: false},
    //                         ]}
    //                 ];
    //
    //                 return responseData;
    //             } catch (error) {
    //                 return []
    //             }
    //         }
    //     );
    // }

    function getAllContinents() {
        return createAsyncThunk(
            `${name}/getAllContinents`,
            async function (args, { getState }) {
                try {
                    const token = getState().auth.value;
                    const headers = {
                        "Authorization": `Bearer ${token}`
                    };
                    const response = await customAxios.get(`/api/continents`,  {headers});
                    //const token = response.token;
                    const responseData = response.data;
                    //alert('responseData: '+JSON.stringify(responseData));
                    // set auth user in redux state
                    return responseData;
                } catch (error) {
                    return [];
                }
            }
        );
    }

    function updateContinentFilter() {
        return createAsyncThunk(
            `${name}/updateContinentFilter`,
            async function (updatedFilter) {
                try {
                    const responseData = updatedFilter;
                    return responseData;
                } catch (error) {
                    return []
                }
            }
        );
    }

    function getAllSearchTerms() {
        return createAsyncThunk(
            `${name}/getAllSearchTerms`,
            async function () {
                try {
                    const responseData = "";
                    return responseData;
                } catch (error) {
                    return {}
                }
            }
        );
    }

    function updateSearchTerm() {
        return createAsyncThunk(
            `${name}/updateSearchTerm`,
            async function (updatedSearchTerm) {
                try {
                    const responseData = updatedSearchTerm;
                    return responseData;
                } catch (error) {
                    return "";
                }
            }
        );
    }

    function getAllProfessionalActivities() {

        return createAsyncThunk(
            `${name}/getAllProfessionalActivities`,
            async function () {
                try {
                    const activity_count_ranges = [
                        {id: 1, display_name: '1-100', min_value:1, max_value: 100},
                        {id: 2, display_name: '101-500', min_value:101, max_value: 500},
                        {id: 3, display_name: '501-1000', min_value:501, max_value: 1000},
                        {id: 4, display_name: '1001-5000', min_value:1001, max_value: 5000},
                        {id: 5, display_name: '>5001', min_value:5001, max_value: 100000}
                    ];
                    const responseData = [
                        {id: 1, name: "trials_count", display_name: "Clinical Trials", identification_project: true, profile_project: true, selected: false, selected_range_id:1, activity_count_ranges: activity_count_ranges},
                        {id: 2, name: "pub_count", display_name: "Publications", identification_project: true, profile_project: true, selected: false, selected_range_id:1, activity_count_ranges: activity_count_ranges},
                        {id: 3, name: "conference_count", display_name: "Conferences and Events", identification_project: true, profile_project: true, selected: false, selected_range_id:1, activity_count_ranges: activity_count_ranges},
                        {id: 4, name: "association_count", display_name: "Associations", identification_project: true, profile_project: false, selected: false, selected_range_id:1, activity_count_ranges: activity_count_ranges},
                        {id: 5, name: "awards_count", display_name: "Awards", identification_project: false, profile_project: true, selected: false, selected_range_id:1, activity_count_ranges: activity_count_ranges},
                    ];

                    return responseData;
                } catch (error) {
                    return []
                }
            }
        );
    }

    function updateProfessionalActivityFilter() {
        return createAsyncThunk(
            `${name}/updateProfessionalActivityFilter`,
            async function (updatedFilter) {
                try {
                    const responseData = updatedFilter;
                    return responseData;
                } catch (error) {
                    return []
                }
            }
        );
    }

    function getAllProfileCompletenessOptions() {

        return createAsyncThunk(
            `${name}/getAllProfileCompletenessOptions`,
            async function () {
                try {
                    const responseData = [
                        {id: 1, name: 20, display_name: "Mini Profiles", selected: false},
                        {id: 2, name: 100, display_name: "Full Profiles", selected: false}
                    ];

                    return responseData;
                } catch (error) {
                    return []
                }
            }
        );
    }

    function updateProfileCompletenessOptionFilter() {
        return createAsyncThunk(
            `${name}/updateProfileCompletenessOptionFilter`,
            async function (updatedFilter) {
                try {
                    const responseData = updatedFilter;
                    return responseData;
                } catch (error) {
                    return []
                }
            }
        );
    }

    function setFilter() {
        return createAsyncThunk(
            `${name}/setFilter`,
            async function (data) {
                try {
                    const responseData = data;
                    return responseData;
                } catch (error) {
                    return {}
                }
            }
        );
    }

}

function createExtraReducers() {
    return (builder) => {
        getAllSpecialities();
        updateSpecialityFilter();
        getAllContinents();
        updateContinentFilter();
        getAllSearchTerms();
        updateSearchTerm();
        getAllProfessionalActivities();
        updateProfessionalActivityFilter();
        getAllProfileCompletenessOptions();
        updateProfileCompletenessOptionFilter();
        setFilter();

        function getAllSpecialities() {
            var { pending, fulfilled, rejected } = extraActions.getAllSpecialities;
            builder
                .addCase(pending, (state) => {
                    state.filter = {
                        ...state.filter,
                        specialities: { loading: true }
                    };
                })
                .addCase(fulfilled, (state, action) => {
                    state.filter = {
                        ...state.filter,
                        specialities: { value: action.payload }
                    };
                })
                .addCase(rejected, (state, action) => {
                    state.filter = {
                        ...state.filter,
                        specialities: { error: action.error }
                    };
                });
        }

        function updateSpecialityFilter() {
            var { pending, fulfilled, rejected } = extraActions.updateSpecialityFilter;
            builder
                .addCase(pending, (state) => {
                    state.filter = {
                        ...state.filter,
                        specialities: { loading: true }
                    };
                })
                .addCase(fulfilled, (state, action) => {
                    state.filter = {
                        ...state.filter,
                        specialities: { value: action.payload }
                    };
                })
                .addCase(rejected, (state, action) => {
                    state.filter = {
                        ...state.filter,
                        specialities: { error: action.error }
                    };
                });
        }

        function getAllContinents() {
            var { pending, fulfilled, rejected } = extraActions.getAllContinents;
            builder
                .addCase(pending, (state) => {
                    state.filter = {
                        ...state.filter,
                        continents: { loading: true }
                    };
                })
                .addCase(fulfilled, (state, action) => {
                    state.filter = {
                        ...state.filter,
                        continents: { value: action.payload }
                    };
                })
                .addCase(rejected, (state, action) => {
                    state.filter = {
                        ...state.filter,
                        continents: { error: action.error }
                    };
                });
        }

        function updateContinentFilter() {
            var { pending, fulfilled, rejected } = extraActions.updateContinentFilter;
            builder
                .addCase(pending, (state) => {
                    state.filter = {
                        ...state.filter,
                        continents: { loading: true }
                    };
                })
                .addCase(fulfilled, (state, action) => {
                    state.filter = {
                        ...state.filter,
                        continents: { value: action.payload }
                    };
                })
                .addCase(rejected, (state, action) => {
                    state.filter = {
                        ...state.filter,
                        continents: { error: action.error }
                    };
                });
        }

        function getAllSearchTerms() {
            var { pending, fulfilled, rejected } = extraActions.getAllSearchTerms;
            builder
                .addCase(pending, (state) => {
                    state.filter = {
                        ...state.filter,
                        search_terms: { loading: true }
                    };
                })
                .addCase(fulfilled, (state, action) => {
                    state.filter = {
                        ...state.filter,
                        search_terms: { value: action.payload }
                    };
                })
                .addCase(rejected, (state, action) => {
                    state.filter = {
                        ...state.filter,
                        search_terms: { error: action.error }
                    };
                });
        }

        function updateSearchTerm() {
            var { pending, fulfilled, rejected } = extraActions.updateSearchTerm;
            builder
                .addCase(pending, (state) => {
                    state.filter = {
                        ...state.filter,
                        search_terms: { loading: true }
                    };
                })
                .addCase(fulfilled, (state, action) => {
                    state.filter = {
                        ...state.filter,
                        search_terms: { value: action.payload }
                    };
                })
                .addCase(rejected, (state, action) => {
                    state.filter = {
                        ...state.filter,
                        search_terms: { error: action.error }
                    };
                });
        }

        function getAllProfessionalActivities() {
            var { pending, fulfilled, rejected } = extraActions.getAllProfessionalActivities;
            builder
                .addCase(pending, (state) => {
                    state.filter = {
                        ...state.filter,
                        professional_activities: { loading: true }
                    };
                })
                .addCase(fulfilled, (state, action) => {
                    state.filter = {
                        ...state.filter,
                        professional_activities: { value: action.payload }
                    };
                })
                .addCase(rejected, (state, action) => {
                    state.filter = {
                        ...state.filter,
                        professional_activities: { error: action.error }
                    };
                });
        }

        function updateProfessionalActivityFilter() {
            var { pending, fulfilled, rejected } = extraActions.updateProfessionalActivityFilter;
            builder
                .addCase(pending, (state) => {
                    state.filter = {
                        ...state.filter,
                        professional_activities: { loading: true }
                    };
                })
                .addCase(fulfilled, (state, action) => {
                    state.filter = {
                        ...state.filter,
                        professional_activities: { value: action.payload }
                    };
                })
                .addCase(rejected, (state, action) => {
                    state.filter = {
                        ...state.filter,
                        professional_activities: { error: action.error }
                    };
                });
        }

        function getAllProfileCompletenessOptions() {
            var { pending, fulfilled, rejected } = extraActions.getAllProfileCompletenessOptions;
            builder
                .addCase(pending, (state) => {
                    state.filter = {
                        ...state.filter,
                        profile_completeness_options: { loading: true }
                    };
                })
                .addCase(fulfilled, (state, action) => {
                    state.filter = {
                        ...state.filter,
                        profile_completeness_options: { value: action.payload }
                    };
                })
                .addCase(rejected, (state, action) => {
                    state.filter = {
                        ...state.filter,
                        profile_completeness_options: { error: action.error }
                    };
                });
        }

        function updateProfileCompletenessOptionFilter() {
            var { pending, fulfilled, rejected } = extraActions.updateProfileCompletenessOptionFilter;
            builder
                .addCase(pending, (state) => {
                    state.filter = {
                        ...state.filter,
                        profile_completeness_options: { loading: true }
                    };
                })
                .addCase(fulfilled, (state, action) => {
                    state.filter = {
                        ...state.filter,
                        profile_completeness_options: { value: action.payload }
                    };
                })
                .addCase(rejected, (state, action) => {
                    state.filter = {
                        ...state.filter,
                        profile_completeness_options: { error: action.error }
                    };
                });
        }

        function setFilter() {
            var { fulfilled } = extraActions.setFilter;
            builder
                .addCase(fulfilled, (state, action) => {
                    //alert('action.payload.continents: '+JSON.stringify(action.payload.continents));
                    state.filter = {
                        specialities: { value: action.payload.specialities},
                        continents: { value: action.payload.continents},
                        search_terms: { value: {search_terms: action.payload.search_terms}},
                        professional_activities: { value: action.payload.professional_activities},
                        profile_completeness_options: { value: action.payload.profile_completeness_options}
                    };
                })

        }

    };
}
